import {isAlphaProfile, isBetaProfile, isDevProfile, isLocalProfile, isRealProfile, isTestProfile} from '../config'

import {UNIT_ID} from './glad'

export const BannerType = {
    /** 포인트 연간안내 배너 */
    MEMBERSHIP_ANNUAL_GUIDE: 'MEMBERSHIP_ANNUAL_GUIDE',
    /** 포인트 안내 배너 */
    MEMBERSHIP_GUIDE: 'MEMBERSHIP_GUIDE',
    /** 포인트 가입 안내 배너 */
    MEMBERSHIP_PROMOTION_GUIDE: 'MEMBERSHIP_PROMOTION_GUIDE',
    /** 네이버통장 팝업 유도 광고 배너 */
    NAVER_BANK_PROMOTION_POPUP: 'NAVER_BANK_PROMOTION_POPUP',
    /** 네이버통장 팝업 유도 광고 배너 PC */
    NAVER_BANK_PC_PROMOTION_POPUP: 'NAVER_BANK_PC_PROMOTION_POPUP',
    /** 멤버십 팝업 유도 배너 */
    MEMBERSHIP_PROMOTION_POPUP: 'MEMBERSHIP_PROMOTION_POPUP',
    /** 충전결제 프로모션 배너 */
    CHARGE_POINT_PROMOTION_POPUP: 'CHARGE_POINT_PROMOTION_POPUP',
    /** 충전결제 사용 가이드 배너 */
    CHARGE_POINT_METHOD_GUIDE: 'CHARGE_POINT_METHOD_GUIDE',
    /** 신한 제휴 카드 배너 */
    SHINHAN_PARTNERSHIP_BANNER: 'SHINHAN_PARTNERSHIP_BANNER',
    /** 멤버십 PLCC 카드 배너 */
    MEMBERSHIP_PLCC_BANNER: 'MEMBERSHIP_PLCC_BANNER',
    /** 멤버십 PLCC 카드 금액 배너 */
    MEMBERSHIP_PLCC_PRICE_BANNER: 'MEMBERSHIP_PLCC_PRICE_BANNER',
    /** 멤버십 주문서 일반 가입 배너 */
    MEMBERSHIP_ORDERSHEET_BANNER: 'MEMBERSHIP_ORDERSHEET_BANNER',
    /** 멤버십 주문서 가입 안내 배너 */
    MEMBERSHIP_ORDERSHEET_JOIN_BANNER: 'MEMBERSHIP_ORDERSHEET_JOIN_BANNER',
    /** 후불결제 신규 가입 안내 배너 */
    PL_JOIN_BANNER: 'PL_JOIN_BANNER',
    /** 후불결제 사용 안내 배너 */
    PL_JOIN_ENABLED_BANNER: 'PL_JOIN_ENABLED_BANNER',
    /** 멤버십 PLCC 카드간편 배너 */
    MEMBERSHIP_PLCC_EASY_CARD_BANNER: 'MEMBERSHIP_PLCC_EASY_CARD_BANNER',
    /** 멤버십 PLCC 카드간편결제 카드타입 배너 */
    MEMBERSHIP_PLCC_EASY_CARD_CARD_TYPE_BANNER: 'MEMBERSHIP_PLCC_EASY_CARD_CARD_TYPE_BANNER',
    /** 멤버십 PLCC 카드간편결제 버튼타입 배너 */
    MEMBERSHIP_PLCC_EASY_CARD_BUTTON_TYPE_BANNER: 'MEMBERSHIP_PLCC_EASY_CARD_BUTTON_TYPE_BANNER',
    /** 이미지 배너 */
    NEW_IMAGE_BANNER: 'NEW_IMAGE_BANNER',
    /** 팝업배너 조인 배너 */
    PL_JOIN_ORDERSHEET_POPUP_BANNER: 'PL_JOIN_ORDERSHEET_POPUP_BANNER',
    /** 멤버십 최초가입자 프로모션 */
    MEMBERSHIP_FIRST_PROMOTION_POPUP: 'MEMBERSHIP_FIRST_PROMOTION_POPUP',
    /** 후불결제 신규 가입 (2%) 안내 배너 */
    PL_JOIN_TYPE_TWO_PERCENT_BANNER: 'PL_JOIN_TYPE_TWO_PERCENT_BANNER',
    /** 후불결제 신규 가입 (이벤트) 안내 배너 */
    PL_JOIN_EVENT_BANNER: 'PL_JOIN_EVENT_BANNER',
    /** 후불결제 사용 (2%) 안내 배너 */
    PL_JOIN_TYPE_TWO_ENABLED_BANNER: 'PL_JOIN_TYPE_TWO_ENABLED_BANNER',
    /** 후불결제 사용 (이벤트) 안내 배너 */
    PL_JOIN_ENABLED_EVENT_BANNER: 'PL_JOIN_ENABLED_EVENT_BANNER',
    /** GFD로 호출해야 하는 배너 */
    GFD_SDK: 'GFD_SDK',
    /** AML 이행 유도를 위한 배너 */
    AML_GUIDE_POPUP: 'AML_GUIDE_POPUP',
    /** 삼성페이 결제/할인혜택 이벤트 배너 */
    PROMOTION_EVENT_BANNER: 'PROMOTION_EVENT_BANNER',
    /** 일반 플레이트 배너 */
    PLATE_BANNER: 'PLATE_BANNER',
    /** 프로모션 플레이트 배너 */
    PROMOTION_PLATE_BANNER: 'PROMOTION_PLATE_BANNER',
    /** 바로결제 유도 배너 */
    RIGHT_AWAY_PAY_BANNER: 'RIGHT_AWAY_PAY_BANNER',
    /** 결제 대기중 배너 */
    PAYMENT_PENDING: 'PAYMENT_PENDING',
    /** 포인트 뽑기 배너 */
    POINT_PICK: 'POINT_PICK',
    /** 패밀리 결제 - 결제 요청 배너 */
    FAMILY_PAY_REQUEST: 'FAMILY_PAY_REQUEST',
    /** 정기구독 - 마지막 배송 */
    LAST_DELIVERY: 'LAST_DELIVERY',
    /** 주문상세 > 멤버십 소급대상(당일 결제건) 배너  */
    MEMBERSHIP_ORDERDETAIL_TODAY: 'MEMBERSHIP_ORDERDETAIL_TODAY',
    /** 주문상세 > 멤버십 소급미대상(과거 주문건) 배너  */
    MEMBERSHIP_ORDERDETAIL_JOIN: 'MEMBERSHIP_ORDERDETAIL_JOIN',
} as const

export type BannerTypeType = Constant<typeof BannerType>

export const BannerCardType = {
    /** 멤버십 현대 PLCC */
    HYUNDAI_MEMBERSHIP: 'HYUNDAI_MEMBERSHIP',
    /** 삼성 TAPTAP */
    SAMSUNG_TAPTAP: 'SAMSUNG_TAPTAP',
    /** 네이버페이 머니카드 */
    NAVERPAY_MONEYCARD: 'NAVERPAY_MONEYCARD',
    /** 신한 프로모션  */
    SHINHAN_LINE_FRIENDS: 'SHINHAN_LINE_FRIENDS',
    /** 롯데 프로모션  */
    LOTTE_NPAY_LOCA: 'SHOPPING_AND_LOKA',
    /** 삼성 프로모션  */
    SAMSUNG_PROMOTION: 'C7',
    /** 현대 프로모션  */
    HYUNDAI_PROMOTION: 'CH',
    /** 신한 프로모션  */
    SHINHAN_PROMOTION: 'C0',
    /** 롯데 프로모션  */
    LOTTE_PROMOTION: 'C5',
    /** 국민행복 삼성카드 */
    KOOKMIN_HAPPINESS_SAMSUNG: 'KOOKMIN_HAPPINESS_SAMSUNG',
    /** 쇼핑앤로카 */
    SHOPPING_AND_LOKA_PLAN_PLUS: 'SHOPPING_AND_LOKA_PLAN_PLUS',
    C5_SHOPPING_AND_LOKA_PLAN_PLUS: 'C5_SHOPPING_AND_LOKA_PLAN_PLUS',
} as const

export type BannerCardTypeType = Constant<typeof BannerCardType>

/**
 * ref
 * - wiki.fin.nvaercorp.com/pages/viewpage.action?pageId=46025480
 */
export const BannerArea = {
    /** 카드 간편결제 영역 */
    EASY_PAY_CREDIT_CARD: 'EASY_PAY_CREDIT_CARD',
    /** 카드 간편결제 동선 */
    EASY_PAY_CREDIT_CARD_MOVEMENT_TYPE: 'EASY_PAY_CREDIT_CARD_MOVEMENT_TYPE',
    /** 카드 간편결제 카드 리스트 영역 */
    EASY_PAY_CREDIT_CARD_CARD_TYPE: 'EASY_PAY_CREDIT_CARD_CARD_TYPE',
    EASY_PAY_CREDIT_CARD_BUTTON_TYPE: 'EASY_PAY_CREDIT_CARD_BUTTON_TYPE',
    /** 계좌 간편결제 영역 */
    EASY_PAY_BANK: 'EASY_PAY_BANK',
    /** 삼성페이 영역 */
    SAMSUNG_PAY: 'SAMSUNG_PAY',
    /** 삼성페이 결제/혜택 이벤트 영역 */
    SAMSUNG_PAY_EVENT: 'SAMSUNG_PAY_EVENT',
    /** 신용카드 영역 */
    CREDIT_CARD: 'CREDIT_CARD',
    BANK: 'BANK',
    /** 일반결제 */
    SKIP: 'SKIP',
    VIRTUAL_ACCOUNT: 'VIRTUAL_ACCOUNT',
    MOBILE: 'MOBILE',
    /** 모바일 팝업 */
    MOBILE_POPUP: 'MOBILE_POPUP',
    CHARGED_POINT: 'CHARGED_POINT',
    /** 후불결제 영역 */
    PAY_LATER: 'PAY_LATER',
    PAY_LATER_ENABLED: 'PAY_LATER_ENABLED',
    /** 포인트 혜택 영역 */
    EXPECTED_PRICE_BOTTOM: 'EXPECTED_PRICE_BOTTOM',
    /** 주문완료 영역 */
    ORDER_DONE: 'ORDER_DONE',
    /** 주문완료 팝업 */
    ORDER_DONE_POPUP: 'ORDER_DONE_POPUP',
    /** 주문상세 배너 영역 */
    ORDER_DETAIL_HEADER: 'ORDER_DETAIL_HEADER',
    ORDER_DETAIL_POPUP: 'ORDER_DETAIL_POPUP',
    /** 주문상세 포인트 혜택 하단 배너 영역 */
    BELOW_POINT_BENEFIT: 'BELOW_POINT_BENEFIT',
    /** 주문완료 타이틀 아래 영역 */
    ORDER_DONE_UNDER_TITLE: 'ORDER_DONE_UNDER_TITLE',
    /** 알람 영역 */
    ALARM: 'ALARM',
    /** 구매확정 하단 */
    PURCHASE_DECISION_DONE_BOTTOM: 'PURCHASE_DECISION_DONE_BOTTOM',
    /** 패밀리결제 */
    FAMILY_PAY: 'FAMILY_PAY',
} as const

export type BannerAreaType = Constant<typeof BannerArea>

export const BannerSubArea = {
    /** 카드 간편결제 동선 */
    EASY_PAY_CREDIT_CARD_MOVEMENT_TYPE: 'EASY_PAY_CREDIT_CARD_MOVEMENT_TYPE',
    /** 카드 간편결제 카드 리스트 영역 */
    EASY_PAY_CREDIT_CARD_CARD_TYPE: 'EASY_PAY_CREDIT_CARD_CARD_TYPE',
    /** 카드 간편결제 카드 리스트 영역의 버튼 영역 */
    EASY_PAY_CREDIT_CARD_BUTTON_TYPE: 'EASY_PAY_CREDIT_CARD_BUTTON_TYPE',
    /** 제휴 카드 배너 */
    AFFILIATED_CARD_BANNER: 'AFFILIATED_CARD_BANNER',
} as const

export type BannerSubAreaType = Constant<typeof BannerSubArea>

export const BannerChannel = {
    PC: 'PC',
    MOBILE: 'MOBILE',
} as const

export type BannerChannelType = Constant<typeof BannerChannel>

export const BannerPage = {
    /** 주문서 */
    ORDER: 'ORDER',
    /** 주문완료 */
    ORDER_DONE: 'ORDER_DONE',
    /** 주문상세 */
    ORDER_DETAIL: 'ORDER_DETAIL',
    /** 구매확정 */
    PURCHASE_DECISION_DONE: 'PURCHASE_DECISION_DONE',
} as const

export type BannerPageType = Constant<typeof BannerPage>

export const BannerRule = {
    /** 멤버십 미가입 */
    NOT_SUBSCRIBE_MEMBERSHIP: 'NOT_SUBSCRIBE_MEMBERSHIP',
    /** 멤버십 가입 */
    SUBSCRIBE_MEMBERSHIP: 'SUBSCRIBE_MEMBERSHIP',
    /** 연간 멤버십 미가입 */
    NOT_SUBSCRIBE_ANNUAL_MEMBERSHIP: 'NOT_SUBSCRIBE_ANNUAL_MEMBERSHIP',
    /** 연간 멤버십 가입 */
    SUBSCRIBE_ANNUAL_MEMBERSHIP: 'SUBSCRIBE_ANNUAL_MEMBERSHIP',
    /** 패밀리 멤버십 대표 */
    IS_HEAD_FAMILY_MEMBERSHIP: 'IS_HEAD_FAMILY_MEMBERSHIP',
    /** 멤버십 당일 가입 */
    IS_JOINED_MEMBERSHIP_TODAY: 'IS_JOINED_MEMBERSHIP_TODAY',
    /** 멤버십 당일 미가입 */
    IS_NOT_JOINED_MEMBERSHIP_TODAY: 'IS_NOT_JOINED_MEMBERSHIP_TODAY',
    /** 멤버십 PLCC 미가입 */
    IS_NOT_MEMBERSHIP_PLCC: 'IS_NOT_MEMBERSHIP_PLCC',
    /**  당일 주문건 예상 적립금 존재 */
    EXISTS_MEMBERSHIP_REWARD_TODAY: 'EXISTS_MEMBERSHIP_REWARD_TODAY',
    /** 당월 주문건 적립금 존재 */
    EXISTS_MEMBERSHIP_REWARD_THIS_MONTH: 'EXISTS_MEMBERSHIP_REWARD_THIS_MONTH',
    /** 적립 제외 대상 */
    IS_INCLUDED_BENEFIT_EXCEPT_CATEGORY: 'IS_INCLUDED_BENEFIT_EXCEPT_CATEGORY',
    /** 적립 제외 미대상 */
    IS_NOT_INCLUDED_BENEFIT_EXCEPT_CATEGORY: 'IS_NOT_INCLUDED_BENEFIT_EXCEPT_CATEGORY',
    /** 해당 주문 멤버십 가입 상태에서 구매 */
    IS_ORDER_MEMBERSHIP: 'IS_ORDER_MEMBERSHIP',
    /** 네이버 통장 미가입 */
    IS_NOT_NAVER_BANK_JOINED: 'IS_NOT_NAVER_BANK_JOINED',
    /** 포인트 결제 (적립, 충포) */
    IS_PAYMENT_POINT: 'IS_PAYMENT_POINT',
    /** 카드 결제 */
    IS_PAYMENT_CARD: 'IS_PAYMENT_CARD',
    /** 충전포인트 프로모션 타겟 (계좌결제, 모바일결제, 나중에 결제(무통장도 나중에 결제로 포함)인 경우) */
    CHARGE_POINT_PROMOTION_TARGET: 'CHARGE_POINT_PROMOTION_TARGET',
    /** 충전포인트로 결제하지 않았을때 */
    NOT_PAYED_WITH_CHARGE_POINT: 'NOT_PAYED_WITH_CHARGE_POINT',
    /** 충전포인트 배너 노출 가능 */
    CHARGE_POINT_BANNER_AVAILABLE: 'CHARGE_POINT_BANNER_AVAILABLE',
    /** 체크카드만 보유 여부 O */
    CHECK_CARD_ONLY_INCLUDED: 'CHECK_CARD_ONLY_INCLUDED',
    /** 체크카드만 보유 여부 X */
    NOT_CHECK_CARD_ONLY_INCLUDED: 'NOT_CHECK_CARD_ONLY_INCLUDED',
    /** 신한 제휴 카드 미보유 */
    NOT_HAS_SHINHAN_PARTNERSHIP_CARD: 'NOT_HAS_SHINHAN_PARTNERSHIP_CARD',
    /** 현대 PLCC 카드 미보유 */
    NOT_HAS_MEMBERSHIP_PLCC_CARD: 'NOT_HAS_MEMBERSHIP_PLCC_CARD',
    /** 성인 O */
    IS_ADULT: 'IS_ADULT',
    /** 멤버십 최초 가입 */
    IS_FIRST_MEMBERSHIP_JOINED: 'IS_FIRST_MEMBERSHIP_JOINED',
    /** 본인 인증 O */
    IS_SELF_IDENTIFIED: 'IS_SELF_IDENTIFIED',
    /** 신규 후불결제 후보 대상 */
    IS_NEW_PL_CANDIDATE: 'IS_NEW_PL_CANDIDATE',
    IBE_MEMBERSHIP: 'IBE_MEMBERSHIP',
    /** 현대 PLCC 카드 보유 (회원 결과만) */
    IS_MEMBERSHIP_PLCC: 'IS_MEMBERSHIP_PLCC',
    /** 현대 PLCC 카드 보유 (회원 결과 및 간편 결제 2차 검증) */
    HAS_MEMBERSHIP_PLCC_CARD: 'HAS_MEMBERSHIP_PLCC_CARD',
    /** 후불결제 테스트 그룹 O */
    IS_PAY_LATER_TEST_GROUP: 'IS_PAY_LATER_TEST_GROUP',
    /** 카드상품코드 미보유 */
    NOT_HAS_CARD_PRODUCT_CODE: 'NOT_HAS_CARD_PRODUCT_CODE',
    /** 카드사 선할인 프로모션 노출규칙 */
    IS_CARD_PROMOTION_APPLICABLE: 'IS_CARD_PROMOTION_APPLICABLE',
    /** 멤버십 혜택(NV_BENF_YN) 상품주문 O */
    IS_MEMBERSHIP_BENEFIT_ORDER: 'IS_MEMBERSHIP_BENEFIT_ORDER',
    /** 멤버십 혜택(NV_BENF_YN) 상품주문 X */
    IS_NON_MEMBERSHIP_BENEFIT_ORDER: 'IS_NON_MEMBERSHIP_BENEFIT_ORDER',
    /** 당일 결제완료 O */
    IS_PAYMENT_COMPLETED_TODAY: 'IS_PAYMENT_COMPLETED_TODAY',
    /** 당일 결제완료 X */
    IS_PAYMENT_NOT_COMPLETED_TODAY: 'IS_PAYMENT_NOT_COMPLETED_TODAY',
} as const

export type BannerRuleType = Constant<typeof BannerRule>

/** GladBanner 사용 지면 정의 */
export const GladBannerPage = {
    ORDER_SHEET: 'ORDER_SHEET',
    ORDER_RESULT: 'ORDER_RESULT',
    ORDER_RESULT_CENTER: 'ORDER_RESULT_CENTER',
    PAYMENT_METHOD: 'PAYMENT_METHOD',
    PURCHASE_CONFIRMATION: 'PURCHASE_CONFIRMATION',
} as const

export type GladBannerPageType = Constant<typeof GladBannerPage>

export type PaymentMethodBannerPaymentType =
    | 'recharge-payment'
    | 'easy-bank-payment'
    | 'easy-card-payment'
    | 'normal-payment'

export const PaymentMethodGladBannerInfo = {
    RechargePaymentBottomBanner: {
        unitIds: [UNIT_ID.P_PAY_PAYMENT_POINT, UNIT_ID.M_PAY_PAYMENT_POINT],
        paymentType: 'recharge-payment',
    },
    DiconPaymentMethodRechargePaymentBottomBanner: {
        unitIds: [UNIT_ID.P_PAY_DICON_POINT_REG, UNIT_ID.M_PAY_DICON_POINT_REG],
        paymentType: 'recharge-payment',
    },
    EasyBankBottomBanner: {
        unitIds: [UNIT_ID.P_PAY_PAYMENT_BB, UNIT_ID.M_PAY_PAYMENT_BB],
        paymentType: 'easy-bank-payment',
    },
    EasyCardBottomBanner: {
        unitIds: [UNIT_ID.P_PAY_PAYMENT_CARD, UNIT_ID.M_PAY_PAYMENT_CARD],
        paymentType: 'easy-card-payment',
    },
    CardBottomBanner: {
        unitIds: [UNIT_ID.P_PAY_PAYMENT_OTHER, UNIT_ID.M_PAY_PAYMENT_OTHER],
        paymentType: 'normal-payment',
    },
    PayNextBottomBanner: {
        unitIds: [UNIT_ID.P_PAY_PAYMENT_LATER, UNIT_ID.M_PAY_PAYMENT_LATER],
        paymentType: 'normal-payment',
    },
} as const

export const GLAD_PHASE = (function () {
    if (isRealProfile) {
        return 'real'
    }
    if (isLocalProfile) {
        return 'local'
    }
    if (isDevProfile || isAlphaProfile) {
        return 'dev'
    }
    if (isTestProfile) {
        return 'test'
    }
    if (isBetaProfile) {
        return 'stage'
    }

    return 'real'
})()
